import React from 'react';

// ── Icone SVG ─────────────────────────────────────────────────────────────
export const Icon = {
    Dashboard: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>,
    Settings: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>,
    People: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>,
    Book: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>,
    Store: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>,
    Finance: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>,
    Business: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18M3 7v14M21 7v14M3 7l9-4 9 4M9 21V11h6v10" /></svg>,
    Management: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>,
    ControlloGestione: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>,
    BopGo: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" /><polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" /></svg>,
    Adozione: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /></svg>,
    Warehouse: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z"></path><path d="M6 18h12"></path><path d="M6 14h12"></path><rect width="12" height="12" x="6" y="10"></rect></svg>,
};

// ── Struttura Menu (3 Livelli: Macro > Gruppo > Voce) ─────────────────────
// modulo: se presente, la voce è visibile solo se l'utente ha canView su quel modulo.
//         Se assente, è sempre visibile.
export type MenuItem  = { label: string; path: string; modulo?: string };
export type MenuGroup = { label: string; items: MenuItem[] };
export type MenuMacro = { label: string; icon: React.ReactNode; path?: string; groups?: MenuGroup[] };

export const MENU_CONFIG: MenuMacro[] = [
    {
        label: 'Dashboard',
        icon: <Icon.Dashboard />,
        path: '/dashboard',
    },
    {
        label: 'Impostazioni Generali',
        icon: <Icon.Settings />,
        groups: [
            {
                label: 'Configurazione',
                items: [
                    { label: 'Società del gruppo', path: '/impostazioni/societa',    modulo: 'impostazioni.societa'    },
                    { label: 'Sedi',                path: '/impostazioni/sedi',       modulo: 'impostazioni.sedi'       },
                    { label: 'SMTP Email',          path: '/impostazioni/smtp-email', modulo: 'impostazioni.smtp_email' },
                    { label: 'SMTP PEC',            path: '/impostazioni/smtp-pec',   modulo: 'impostazioni.smtp_pec'   },
                    { label: 'Depositi Fissi',      path: '/impostazioni/depositi',        modulo: 'parametri.depositi'           },
                ],
            },
            {
                // Sistemi esterni con cui BOP parla: lo stato di ciascuno è nel
                // riquadro "Integrazioni" della dashboard.
                label: 'Integrazioni',
                items: [
                    { label: 'Integrazione AI',      path: '/impostazioni/integrazione-ai',        modulo: 'impostazioni.integrazione_ai'         },
                    { label: 'Integrazione OpenApi', path: '/impostazioni/integrazione-openapi',   modulo: 'impostazioni.integrazione_openapi'    },
                    { label: 'API esterne',          path: '/dev/api-esterne',                     modulo: 'dev.api_esterne'                      },
                    { label: 'Zoho Sign',            path: '/impostazioni/integrazione-zoho-sign', modulo: 'impostazioni.integrazione_zoho_sign'  },
                    { label: 'Centralino',           path: '/impostazioni/integrazione-centralino', modulo: 'impostazioni.integrazione_centralino' },
                ],
            },
            {
                label: 'Stampe e Report',
                items: [
                    { label: 'Parametri report', path: '/impostazioni/parametri-report', modulo: 'impostazioni.parametri_report' },
                    { label: 'Report',           path: '/impostazioni/report',           modulo: 'impostazioni.report'           },
                    { label: 'Log & Storico Invii', path: '/impostazioni/log-storico-invii', modulo: 'impostazioni.log_storico_invii' },
                ],
            },
            {
                label: 'Funzioni Sviluppatore',
                items: [
                    { label: 'Inizializza dopo rilascio', path: '/dev/init-after-release', modulo: 'dev.init' },
                    { label: 'Dashboard Tecnico',         path: '/dev/dashboard',          modulo: 'dev.dashboard' },
                    { label: 'Configurazione Errori',     path: '/dev/error-config',       modulo: 'dev.error_config' },
                    { label: 'Design System',             path: '/dev/design-system',      modulo: 'dev.design_system' },
                ],
            },
        ],
    },
    {
        label: 'Gestione Utenti',
        icon: <Icon.People />,
        groups: [
            {
                label: 'Utenti e Permessi',
                items: [
                    { label: 'Utenti',            path: '/utenti',                  modulo: 'utenti.gestione' },
                    { label: 'Permessi',          path: '/utenti/permessi',         modulo: 'utenti.permessi' },
                    { label: 'Profili permessi',  path: '/utenti/profili',          modulo: 'utenti.profili' },
                    { label: 'Permessi per voce', path: '/utenti/permessi/matrice', modulo: 'utenti.permessi_matrice' },
                ],
            },
        ],
    },
    {
        label: 'Archivi',
        icon: <Icon.Book />,
        groups: [
            {
                label: 'Parametri Commerciali',
                items: [
                    { label: 'Sconti',    path: '/commerciale/parametri/sconti',    modulo: 'parametri.sconti'    },
                    { label: 'Pagamenti', path: '/commerciale/parametri/pagamenti', modulo: 'parametri.pagamenti' },
                ],
            },
            {
                label: 'Registro Anagrafico',
                items: [
                    { label: 'Registro Anagrafico', path: '/anagrafiche/nominativi', modulo: 'anagrafiche.nominativi' },
                ],
            },
            {
                label: 'Insegne Clienti',
                items: [
                    { label: 'Insegne Clienti',            path: '/anagrafiche/insegne',           modulo: 'anagrafiche.insegne'           },
                    { label: 'Contratto Quadro Insegna',   path: '/anagrafiche/insegne/contratti', modulo: 'anagrafiche.insegne_contratti' },
                    { label: 'Premi Insegna',              path: '/anagrafiche/insegne/premi',     modulo: 'anagrafiche.insegne_premi'     },
                ],
            },
            {
                label: 'Articoli',
                items: [
                    { label: 'Anagrafica Articoli',    path: '/anagrafiche/articoli',                   modulo: 'anagrafiche.articoli'                  },
                    { label: 'Prodotti',               path: '/anagrafiche/prodotti',                   modulo: 'anagrafiche.prodotti'                  },
                    { label: 'Import Listini',          path: '/anagrafiche/articoli/listini',           modulo: 'anagrafiche.articoli_listini'          },
                    { label: 'Aggiorna prezzi da xls',  path: '/anagrafiche/articoli/aggiorna-prezzi',   modulo: 'anagrafiche.articoli_aggiorna_prezzi'  },
                    { label: 'Listini Fornitori',       path: '/anagrafiche/articoli/listini-fornitori', modulo: 'anagrafiche.articoli_listini_fornitori'},
                    { label: 'Sconti Fornitori',        path: '/anagrafiche/articoli/sconti-fornitori',  modulo: 'anagrafiche.articoli_sconti'           },
                    { label: 'Storico prezzi',          path: '/anagrafiche/articoli/storico-prezzi',    modulo: 'anagrafiche.articoli_storico_prezzi'   },
                    { label: 'Articoli Intercambiabili', path: '/archivi/articoli/intercambiabili',      modulo: 'archivi.articoli_intercambiabili'      },
                ],
            },
            {
                label: 'Configurazioni Articoli',
                items: [
                    { label: 'Tutorial configurati',       path: '/archivi/configurazioni/tutorial-configurati',    modulo: 'archivi.tutorial_configurati'    },
                    { label: 'Modelli di configurazione',  path: '/archivi/configurazioni/modelli-configurazione',  modulo: 'archivi.modelli_configurazione'  },
                    { label: 'Articoli preconfigurati',    path: '/archivi/configurazioni/articoli-preconfigurati', modulo: 'archivi.articoli_preconfigurati' },
                    { label: 'Sfridi',                     path: '/archivi/configurazioni-articoli/sfridi',         modulo: 'archivi.sfridi'                  },
                ],
            },
        ],
    },
    {
        label: 'Gestione Commerciale',
        icon: <Icon.Store />,
        groups: [
            {
                label: 'Configurazione Ciclo Attivo',
                items: [
                    { label: 'Configurazione documenti', path: '/commerciale/configurazione/documenti', modulo: 'commerciale.configurazione_documenti' },
                ],
            },
            {
                label: 'CRM - Vendite',
                items: [
                    { label: 'Opportunità',      path: '/commerciale/crm/opportunita',      modulo: 'commerciale.opportunita'    },
                    { label: 'Analisi Vendite',  path: '/commerciale/crm/analisi-vendite',  modulo: 'commerciale.analisi_vendite' },
                ],
            },
            {
                label: 'Commesse',
                items: [
                    { label: 'Gestione Commesse', path: '/commerciale/commesse',   modulo: 'commerciale.commesse'   },
                    { label: 'Fabbisogni Merce',  path: '/commerciale/fabbisogni', modulo: 'commerciale.fabbisogni' },
                    { label: 'Fabbisogni Subappalti', path: '/commerciale/fabbisogni-subappalti', modulo: 'commerciale.fabbisogni_subappalti' },
                ],
            },
            {
                label: 'Capitolati',
                items: [
                    { label: 'Capitolati',        path: '/commerciale/capitolati/lista',   modulo: 'commerciale.capitolati'         },
                    { label: 'Offerte capitolato', path: '/commerciale/capitolati/offerte', modulo: 'commerciale.offerte_capitolato' },
                ],
            },
            {
                label: 'Percorso acquirenti',
                items: [
                    { label: 'Agenda venditori',        path: '/commerciale/percorso/agenda',         modulo: 'commerciale.percorso_agenda'         },
                    { label: 'Buoni emessi',            path: '/commerciale/percorso/buoni',          modulo: 'commerciale.percorso_buoni'          },
                    { label: 'Configurazione percorso', path: '/commerciale/percorso/configurazione', modulo: 'commerciale.percorso_configurazione' },
                    { label: 'Modelli pagina',          path: '/commerciale/percorso/modelli',        modulo: 'commerciale.percorso_configurazione' },
                ],
            },
            {
                label: 'Ciclo Attivo',
                items: [
                    { label: 'Preventivi Clienti', path: '/commerciale/attivo/preventivi', modulo: 'commerciale.preventivi'     },
                    { label: 'Ordini Clienti',     path: '/commerciale/attivo/ordini',     modulo: 'commerciale.ordini_clienti' },
                    { label: 'Contratti',          path: '/commerciale/attivo/contratti',  modulo: 'commerciale.contratti'      },
                    { label: 'Acconti Clienti',    path: '/commerciale/attivo/acconti',    modulo: 'commerciale.acconti'        },
                    { label: 'Distinte',           path: '/commerciale/attivo/distinte',   modulo: 'commerciale.distinte'       },
                    { label: 'DDT Clienti',        path: '/commerciale/attivo/ddt',        modulo: 'commerciale.ddt'            },
                    { label: 'SAL',                path: '/commerciale/attivo/sal',        modulo: 'commerciale.sal'            },
                    { label: 'Fatture',            path: '/commerciale/attivo/fatture',    modulo: 'commerciale.fatture_attive' },
                ],
            },
            {
                label: 'Ciclo Passivo',
                items: [
                    { label: 'Richieste di Acquisto',     path: '/commerciale/passivo/rda',      modulo: 'acquisti.rda'              },
                    { label: 'Ordini Fornitori',          path: '/commerciale/passivo/ordini',   modulo: 'acquisti.ordini_fornitori' },
                    { label: 'Conferme Ordini Fornitori', path: '/commerciale/passivo/conferme', modulo: 'acquisti.conferme'         },
                    { label: 'DDT/SAL Fornitori',         path: '/commerciale/passivo/ddt-sal',  modulo: 'acquisti.ddt_sal'          },
                    { label: 'Fatture Fornitori',         path: '/commerciale/passivo/fatture',  modulo: 'acquisti.fatture_passive'  },
                ],
            },
        ],
    },
    {
        label: 'Magazzino / Logistica',
        icon: <Icon.Warehouse />,
        groups: [
            {
                label: 'CRUSCOTTO',
                items: [
                    { label: 'Cruscotto Allestimento', path: '/magazzino/cruscotto', modulo: 'magazzino.cruscotto' },
                ],
            },
            {
                label: 'DEPOSITI',
                items: [
                    { label: 'Depositi', path: '/magazzino/depositi', modulo: 'magazzino.depositi' },
                ],
            },
            {
                label: 'CONFIGURAZIONI',
                items: [
                    { label: 'Causali Movimento', path: '/magazzino/causali-movimento', modulo: 'magazzino.causali_movimento' },
                ],
            },
            {
                label: 'MOVIMENTI',
                items: [
                    { label: 'Movimenti', path: '/magazzino/movimenti', modulo: 'magazzino.movimenti' },
                ],
            },
            {
                label: 'INVENTARIO',
                items: [
                    { label: 'Giacenze',         path: '/magazzino/giacenze',          modulo: 'magazzino.giacenze' },
                    { label: 'Inventari Fisici', path: '/magazzino/inventari-fisici',  modulo: 'magazzino.inventari_fisici' },
                ],
            },
        ],
    },
    {
        label: 'Gestione Amministrativa',
        icon: <Icon.Finance />,
        groups: [
            {
                label: 'Parametri Amministrazione',
                items: [
                    { label: 'Banche aziendali',        path: '/amministrazione/banche',            modulo: 'amministrazione.banche'            },
                    { label: 'Archivio banche ABI/CAB', path: '/amministrazione/anagrafica-banche', modulo: 'amministrazione.anagrafica_banche' },
                    { label: 'Codici IVA',              path: '/amministrazione/codici-iva',        modulo: 'amministrazione.codici_iva'        },
                ],
            },
            {
                label: 'Contabilità Generale',
                items: [
                    { label: 'Piano dei conti CO.GE', path: '/amministrazione/piano-conti-coge', modulo: 'amministrazione.piano_conti_coge' },
                    { label: 'Associazioni conti',    path: '/amministrazione/associazioni-conti', modulo: 'amministrazione.associazioni_conti' },
                    { label: 'Sezionali IVA',         path: '/amministrazione/sezionali-iva',   modulo: 'amministrazione.sezionali_iva'   },
                    { label: 'Registri contabili',    path: '/amministrazione/registri-contabili', modulo: 'amministrazione.registri_contabili' },
                    { label: 'Causali contabili',     path: '/amministrazione/causali-contabili',  modulo: 'amministrazione.causali_contabili'  },
                    { label: 'Scritture contabili',   path: '/amministrazione/scritture-contabili', modulo: 'amministrazione.scritture_contabili' },
                    { label: 'Liquidazioni IVA',      path: '/amministrazione/liquidazioni-iva',    modulo: 'amministrazione.liquidazioni_iva'    },
                ],
            },
        ],
    },
    {
        label: 'Controllo di gestione',
        icon: <Icon.ControlloGestione />,
        groups: [
            {
                label: 'Contabilità Analitica',
                items: [
                    { label: 'Piano dei conti analitica', path: '/controllo-gestione/piano-conti-analitica', modulo: 'controllo_gestione.piano_conti_analitica' },
                    { label: 'Movimenti contab. analitica', path: '/controllo-gestione/movimenti-contabilita-analitica', modulo: 'controllo_gestione.movimenti_analitici' },
                    { label: 'Caricamento massivo movimenti', path: '/controllo-gestione/caricamento-massivo-movimenti', modulo: 'controllo_gestione.movimenti_massivi' },
                    { label: 'Budget contab. analitica', path: '/controllo-gestione/budget-contabilita-analitica', modulo: 'controllo_gestione.budget_analitico' },
                    { label: 'Bilancio contab. analitica', path: '/controllo-gestione/bilancio-contabilita-analitica', modulo: 'controllo_gestione.bilancio_analitico' },
                ],
            },
        ],
    },
    {
        label: 'Gestione Aziendale',
        icon: <Icon.Business />,
        groups: [
            {
                label: 'HR',
                items: [
                    { label: 'Dipendenti',            path: '/aziendale/dipendenti',                          modulo: 'aziendale.dipendenti'                   },
                    { label: 'Selezioni',             path: '/aziendale/selezioni',                           modulo: 'aziendale.selezioni'                    },
                    { label: 'Dispositivi Aziendali', path: '/gestione-aziendale/hr/dispositivi',             modulo: 'aziendale.hr.dispositivi'               },
                    { label: 'Assegnazione Dispositivi', path: '/gestione-aziendale/hr/assegnazioni-dispositivi', modulo: 'aziendale.hr.assegnazioni_dispositivi' },
                ],
            },
            {
                label: 'Ricarica veicoli',
                items: [
                    { label: 'Colonnine',  path: '/gestione-aziendale/ricarica/colonnine',  modulo: 'aziendale.ricarica.colonnine'  },
                    { label: 'Badge',      path: '/gestione-aziendale/ricarica/badge',      modulo: 'aziendale.ricarica.badge'      },
                    { label: 'Sessioni',   path: '/gestione-aziendale/ricarica/sessioni',   modulo: 'aziendale.ricarica.sessioni'   },
                    { label: 'Riaddebiti', path: '/gestione-aziendale/ricarica/riaddebiti', modulo: 'aziendale.ricarica.riaddebiti' },
                ],
            },
            {
                label: 'Risk Management',
                items: [
                    { label: 'Rischi Aziendali',    path: '/aziendale/rischi',              modulo: 'aziendale.rischi'              },
                    { label: 'Associazione Rischi', path: '/aziendale/associazione-rischi', modulo: 'aziendale.associazione_rischi' },
                    { label: 'Polizze',             path: '/aziendale/polizze',             modulo: 'aziendale.polizze'             },
                ],
            },
            {
                label: 'Email Massive',
                items: [
                    { label: 'Invia mail massive', path: '/tecnico/pec-massiva',         modulo: 'aziendale.pec'         },
                    { label: 'Storico Job Email',  path: '/tecnico/pec-massiva/storico', modulo: 'aziendale.pec_storico' },
                ],
            },
            {
                label: 'Notifiche e Comunicazioni',
                items: [
                    { label: 'Casella Messaggi', path: '/aziendale/messaggi',       modulo: 'aziendale.messaggi_lettura' },
                    { label: 'Nuovo Messaggio',  path: '/aziendale/messaggi/nuovo', modulo: 'aziendale.messaggi_invio'   },
                ],
            },
        ],
    },
    {
        label: 'Management',
        icon: <Icon.Management />,
        groups: [
            {
                label: 'Gestione Finanziaria',
                items: [
                    { label: 'Piano Finanziamenti', path: '/amministrazione/finanziamenti', modulo: 'amministrazione.finanziamenti' },
                    { label: 'Movimenti Finanziamenti', path: '/amministrazione/movimenti-finanziamenti', modulo: 'amministrazione.movimenti_finanziamenti' },
                ],
            },
            {
                label: 'Contratti infragruppo',
                items: [
                    { label: 'Contratti infragruppo', path: '/management/contratti-infragruppo', modulo: 'management.contratti_infragruppo' },
                ],
            },
            {
                label: 'Locazioni immobiliari',
                items: [
                    { label: 'Locazioni', path: '/management/locazioni', modulo: 'management.locazioni' },
                ],
            },
            {
                label: 'Upload Documenti',
                items: [
                    { label: 'Bilanci',               path: '/amministrazione/upload-fiscali/bilanci', modulo: 'amministrazione.bilanci'                 },
                    { label: 'Documenti Ricorrenti',  path: '/aziendale/documenti-ricorrenti',         modulo: 'aziendale.documenti_ricorrenti'          },
                    { label: 'Documenti Societari',   path: '/aziendale/documenti-societari',          modulo: 'aziendale.documenti_societari'           },
                    { label: 'LIPE',                  path: '/amministrazione/upload-fiscali/lipe',    modulo: 'amministrazione.lipe'                    },
                ],
            },
            {
                label: 'Report e Stampe',
                items: [
                    { label: 'Dati completi società', path: '/management/report/dati-completi-societa', modulo: 'management.report_dati_societa' },
                ],
            },
        ],
    },
    {
        label: 'BOP - GO',
        icon: <Icon.BopGo />,
        groups: [
            {
                label: 'Import ordini',
                items: [
                    { label: 'Import ordini Smartix in GO', path: '/bop-go/import-ordini-smartix', modulo: 'bop_go.import_ordini_smartix' },
                    { label: 'Match campi BOP-GO Smartix', path: '/bop-go/match-campi', modulo: 'bop_go.mappatura' },
                ],
            },
            {
                label: 'Dati commerciali da GO',
                items: [
                    { label: 'Costi - fornitori',  path: '/bop-go/costi-fornitori', modulo: 'bop_go.costi_fornitori' },
                    { label: 'Vendita - clienti',  path: '/bop-go/vendita-clienti', modulo: 'bop_go.vendita_clienti' },
                    { label: 'Analisi commesse',   path: '/bop-go/analisi-commesse', modulo: 'bop_go.analisi_commesse' },
                    { label: 'Conto economico',    path: '/bop-go/conto-economico',  modulo: 'bop_go.conto_economico' },
                    { label: 'Riconciliazione dati economici', path: '/bop-go/riconciliazione', modulo: 'bop_go.riconciliazione_economica' },
                ],
            },
        ],
    },
    {
        label: 'Assistenza - Guide',
        icon: <Icon.Book />,
        groups: [
            {
                label: 'Assistenza',
                items: [
                    { label: 'Richieste assistenza', path: '/assistenza/richieste', modulo: 'assistenza.richieste' },
                    { label: 'Knowledge base', path: '/assistenza/knowledge-base', modulo: 'assistenza.knowledge_base' },
                ],
            },
            {
                label: 'Documentazione operativa',
                items: [
                    // Nessun `modulo`: voce sempre visibile a tutti gli utenti autenticati.
                    { label: 'Come funziona il ciclo attivo', path: '/guide/ciclo-attivo' },
                    { label: 'Guida contabilità', path: '/guide/contabilita' },
                ],
            },
        ],
    },
    {
        label: 'Adozione BOP',
        icon: <Icon.Adozione />,
        groups: [
            {
                label: 'Piano di adozione',
                items: [
                    { label: 'Piano di adozione',  path: '/adozione/piano',        modulo: 'adozione.piano' },
                    { label: 'Le mie attività',    path: '/adozione/mie-attivita', modulo: 'adozione.mie_attivita' },
                    { label: 'Monitoraggio gruppo', path: '/adozione/monitoraggio', modulo: 'adozione.monitoraggio' },
                ],
            },
        ],
    },
];

// ── Voce di menu per una path (prefisso più lungo fra le voci con modulo) ──
// Serve all'assistente per sapere da quale pagina parte la chat.
export function trovaVoceMenuPerPath(pathname: string): MenuItem | null {
  let migliore: MenuItem | null = null;
  for (const macro of MENU_CONFIG) {
    for (const gruppo of macro.groups ?? []) {
      for (const item of gruppo.items) {
        if (!item.modulo) continue;
        if (pathname === item.path || pathname.startsWith(item.path + '/')) {
          if (!migliore || item.path.length > migliore.path.length) migliore = item;
        }
      }
    }
  }
  return migliore;
}
